const ChallengeType = {
  TwentyOneDay: '21 Day',
  ThirtyDay: '30 Day',
  SixWeek: '6 Week',
  LowImpact: 'Low Impact',
  Flex: 'Flex',
} as const

export { ChallengeType }
